const actionStack = [];

export function actionTrackerPlugin(store) {
    store.subscribeAction({
        before(action) {
            actionStack.push(action.type);
        },
        after(action) {
            const i = actionStack.lastIndexOf(action.type);
            if (i !== -1) actionStack.splice(i, 1);
        },
        error(action) {
            const i = actionStack.lastIndexOf(action.type);
            if (i !== -1) actionStack.splice(i, 1);
        },
    });
}

export function getActionStack() {
    return actionStack.slice();
}
